module.exports = {"150423100":"大板镇","150423101":"索博日嘎镇","150423102":"宝日勿苏镇","150423103":"查干诺尔镇","150423105":"巴彦琥硕镇","150423200":"西拉沐沦苏木","150423201":"巴彦塔拉苏木","150423202":"幸福之路苏木","150423203":"查干沐沦苏木","150423400":"大板煤电化基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150423.json
// module id = 375
// module chunks = 0